import { composeGuards, redirectIfUnauthorized } from '@/app/shared/utils/router-guards/auth';
import { redirectWithMainEventScope } from '@/app/shared/utils/router-guards/mainEvent';

const BASE_PATH = '/guest-list';

const GuestListRoutes = [
    {
        path: `${BASE_PATH}/main-events`,
        name: 'GuestListMainEventsList',
        component: () => import('@/app/modules/guestList/MainEventsList/MainEventsList.vue'),
        props: true,
        beforeEnter: composeGuards(
            redirectIfUnauthorized((permissions) => permissions.guestList.mainEventsList),
            redirectWithMainEventScope((mainEventId) => ({
                name: 'GuestListEventsList',
                params: { mainEventId },
            }))
        ),
    },
    {
        path: `${BASE_PATH}/main-events/full-list`,
        name: 'GuestListMainEventsFullList',
        component: () =>
            import('@/app/modules/guestList/MainEventsFullList/MainEventsFullList.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions) => permissions.guestList.mainEventsList),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/events`,
        name: 'GuestListEventsList',
        component: () => import('@/app/modules/guestList/EventsList/EventsList.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions) => permissions.guestList.eventsList),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/events/:eventId/guest-list`,
        name: 'GuestListEventGuestList',
        component: () => import('@/app/modules/guestList/EventGuestList/EventGuestList.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions) => permissions.guestList.guestList),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/events/:eventId/vapp-distribution`,
        name: 'VappDistribution',
        component: () => import('@/app/modules/guestList/VappDistribution/VappDistribution.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions) => permissions.vappDistribution),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/group-dashboard`,
        name: 'GuestListGroupDashboard',
        component: () => import('@/app/modules/guestList/GroupDashboard/GroupDashboard.vue'),
        props: true,
        beforeEnter: composeGuards(
            redirectIfUnauthorized((permissions) => permissions.guestList.guestList)
        ),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/vapp-configuration`,
        name: 'GuestListVappConfiguration',
        component: () => import('@/app/modules/guestList/VappDistribution/VappConfiguration.vue'),
        props: true,
        beforeEnter: composeGuards(
            redirectIfUnauthorized(
                (permissions) => permissions.events.guestOperations.mainEvents.vappConfiguration
            )
        ),
    },
];

export default GuestListRoutes;
